import { Button } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectUserType,
  seledctAlowedpathlist,
} from '../utility/Redux/profile';
import { hasPageAccess } from '../utility/pageAccess';

const SummaryList = () => {
  const navigate = useNavigate();
  const userType = useSelector(selectUserType);
  const allowedPages = useSelector(seledctAlowedpathlist);

  const list = [
    {
      name: 'Sale Summary',
      path: '/Sale_Summary',
      userType: 'MANAGER,USER,ADMIN,STORE',
      onclick: () => {
        navigate('/Sale_Summary');
      },
    },
    {
      name: 'Collection Summary',
      path: '/collection_summary',
      userType: 'MANAGER,USER,ADMIN,STORE',
      onclick: () => {
        navigate('/collection_summary');
      },
    },
    {
      name: 'Day End Summary',
      path: '/day_end_summary',
      userType: 'MANAGER,USER,ADMIN,STORE',
      onclick: () => {
        navigate('/day_end_summary');
      },
    },

    {
      name: 'Payment Reciept Summary',
      path: '/payment_reciept_summary',
      userType: 'MANAGER,ADMIN,STORE',
      onclick: () => {
        navigate('/payment_reciept_summary');
      },
    },
  ];

  return (
    <div className="h-full p-4">
      <div className="grid grid-cols-2 t:grid-cols-4 d:grid-cols-5 ll:grid-cols-6 gap-3  ">
        {list[0] &&
          list.map((e, i) => {
            if (
              e.userType.includes(userType) &&
              hasPageAccess(userType, allowedPages, e.path)
            ) return (
              <Button
                key={i}
                onClick={() => {
                  if (e.onclick) {
                    e.onclick();
                  } else {
                    navigate(e.path);
                  }
                }}
                variant={'contained'}
                style={{
                  textTransform: 'none',
                  backgroundColor: 'transparent',
                  padding: '0px',
                  borderRadius: '7px',
                  overflow: 'hidden',
                }}
              >
                <div className="bg-[#e9e9e5] py-5 w-full text-brown">
                  {e.name}
                </div>
              </Button>
            );
          })}
      </div>
    </div>
  );
};

export default SummaryList;
